<!-- components/Vambee/Chat.vue -->
<template>
  <div id="vambe-chat-container" :class="{ 'chat-bottom-low': isHiddenNavPath, 'chat-bottom-popup': hasPopupCombinado }"></div>
  <div v-if="!isMobile" id="vambe-label-permanent" @click="toggleChat">
    <div class="bg-green-100 relative flex items-center rounded-full px-4 py-2 shadow-md">
      <span class="text-sm font-medium text-VERDE_TOP_CALIDAD">Asesoramiento Online</span>
      <div class="absolute right-[-3.5px]">
        <div class="h-[9.03px] w-[8.77px] -rotate-45 transform"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isMobile = ref(false);
const popupCombinadoVisible = useState('popup-combinado-visible', () => false);
const hasPopupCombinado = computed(() => popupCombinadoVisible.value);

const isHiddenNavPath = computed(() => {
  const rutas = ['instalacion', 'agendamiento', 'checkout'];
  return rutas.some(ruta => route.path.includes(ruta));
});

const toggleChat = () => {
  const btn = document.querySelector('#vambe-webchat-container button[style*="65px"]');
  if (btn) btn.click();
};

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);

  if (document.querySelector('script[src="https://vambeai.com/webchat.js"]')) {
    return;
  }

  window.embeddedWebchatConfig = {
    clientId: "e57e585c-8f6a-48a1-bfa3-760838108dfa",
    channelId: "9c59e698-d7f2-4203-acb7-d515148a763c",
    agentName: "LEÓN Servicio Automotriz",
    agentIconUrl: "/img/vambee/chatbot-leon.png",
    primaryColor: "#ECFDF5",
    secondaryColor: "#ECFDF5",
    darkTheme: false,
    language: "es",
    chatWithUsText: "¿Necesitas ayuda?",
    xPosition: 0,
    yPosition: 0,
  };

  const script = document.createElement('script');
  script.src = "https://vambeai.com/webchat.js";
  script.async = true;
  document.body.appendChild(script);

  document.addEventListener('click', (e) => {
    const button = e.target.closest('#vambe-webchat-container button');
    if (button) {
      const audio = new Audio('/audios/vambee/bubble-sound-3.mp3');
      audio.play().catch(err => console.error('Audio error:', err));
    }
  }, true);

  let lastChatState = null;
  const chatObserver = new MutationObserver(() => {
    const chatWindow = document.querySelector('#chat-window');
    const currentState = !!chatWindow;

    if (currentState !== lastChatState) {
      lastChatState = currentState;
      if (chatWindow && window.innerWidth <= 768) {
        document.body.classList.add('vambe-chat-open');
      } else {
        document.body.classList.remove('vambe-chat-open');
      }
    }
  });

  setTimeout(() => {
    chatObserver.observe(document.body, { childList: true, subtree: true });
  }, 1000);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile);
  document.body.classList.remove('vambe-chat-open');
  delete window.embeddedWebchatConfig;
});
</script>

<style>
/* Ocultar label original de Vambe siempre via opacity */
#vambe-webchat-container .flex.items-center.gap-2:not(.border-webchat-borderFocus) > div:not(#vambe-label-permanent):not(.bg-webchat-primaryFocus) {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Ocultar completamente cuando chat cerrado */
#vambe-webchat-scoped-reset:not(:has(#chat-window)) #vambe-webchat-container .flex.items-center.gap-2:not(.border-webchat-borderFocus) > div:not(#vambe-label-permanent) {
  display: none !important;
}

/* Proteger botón cerrar del chat */
#chat-window .border-webchat-borderFocus .flex.items-center.gap-2 > div {
  display: flex !important;
  opacity: 1 !important;
  visibility: visible !important;
}

#vambe-webchat-scoped-reset {
  z-index: 200 !important;
}

#vambe-webchat-scoped-reset:not(:has(#chat-window)) {
  right: 1rem !important;
  bottom: 2rem !important;
}

#vambe-webchat-scoped-reset:has(#chat-window) {
  right: 1rem !important;
  bottom: 2rem !important;
}

#vambe-label-permanent {
  position: fixed;
  bottom: 2rem;
  right: 6rem;
  z-index: 210;
  cursor: pointer !important;
  user-select: none;
  pointer-events: all !important;
}

#vambe-webchat-container button.rounded-full > svg:first-child {
  pointer-events: none !important;
}

#chat-history-dialog .lucide-message-square-warning {
  stroke: #4CAF50;
}

#chat-history-dialog button.bg-webchat-primary {
  background-color: #4CAF50 !important;
}

#chat-window {
  width: 24rem !important;
  height: 32rem !important;
  max-width: 24rem !important;
  max-height: 32rem !important;
}

#chat-window #chat-history .border-webchat-borderFocus .text-webchat-textMuted svg.lucide-bot {
  stroke: #4CAF50 !important;
}

#chat-window #chat-history svg.lucide-user.text-webchat-primary {
  stroke: #4CAF50 !important;
}

#chat-window #chat-history > div.border-webchat-borderFocus > div.bg-webchat-primary {
  background-color: #4CAF50 !important;
}

#chat-window #chat-history svg.lucide-history {
  stroke: white !important;
}

#chat-window #chat-history .mt-auto button.bg-webchat-primary {
  background-color: #4CAF50 !important;
}

#chat-window #chat-history .mt-auto button.bg-webchat-primary:hover {
  background-color: #45a049 !important;
}

#chat-window .relative.flex.items-center button[type="submit"] {
  background-color: #4CAF50 !important;
}

#chat-window .relative.flex.items-center button[type="submit"] svg {
  stroke: white !important;
}

#vambe-webchat-container div > div.flex.w-full.items-center.justify-center {
  display: none;
}

#vambe-webchat-container .text-webchat-msgInboundText {
  color: #065F46 !important;
}

#vambe-webchat-container > div > div > div.bg-webchat-primary {
  background-color: #ECFDF5 !important;
}

#vambe-webchat-container > div > div > div.bg-webchat-primary.relative.flex.items-center.rounded-full .bg-webchat-primary {
  background-color: #ECFDF5 !important;
}

#vambe-webchat-container div > div > div > span.text-slate-100 {
  color: #065F46 !important;
}

#vambe-webchat-container button svg stop {
  stop-color: #ECFDF5 !important;
}

#vambe-webchat-container button svg ellipse[stroke] {
  stroke: #ECFDF5 !important;
}

#vambe-webchat-container button svg.lucide-headset,
#vambe-webchat-container button svg.lucide-message-circle {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
}

#vambe-webchat-container button.rounded-full::after {
  content: '';
  position: absolute;
  width: 5rem;
  height: 5rem;
  background-image: url('/img/vambee/chatbot-burbuja.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 190;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

#chat-window button::after {
  display: none !important;
}

#vambe-webchat-container > div > div.flex.items-center.justify-center {
  display: none !important;
}

body:has(.chat-bottom-popup) #vambe-webchat-scoped-reset:not(:has(#chat-window)) {
  bottom: 8rem !important;
}

body:has(.chat-bottom-popup) #vambe-webchat-scoped-reset:has(#chat-window) {
  bottom: 8rem !important;
  right: 1rem !important;
}

body:has(.chat-bottom-popup) #vambe-label-permanent {
  bottom: 8rem !important;
}

body:has(.chat-bottom-low) #vambe-webchat-scoped-reset:not(:has(#chat-window)) {
  bottom: 2rem !important;
}

@media (max-width: 768px) {
  #vambe-webchat-scoped-reset:not(:has(#chat-window)) {
    right: 1rem !important;
    bottom: 4rem !important;
  }

  #vambe-webchat-scoped-reset:has(#chat-window) {
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    top: 0 !important;
  }

  body:has(.chat-bottom-low) #vambe-webchat-scoped-reset:not(:has(#chat-window)) {
    bottom: 2rem !important;
  }

  #chat-window {
    width: 100vw !important;
    height: 100dvh !important;
    max-width: 100vw !important;
    max-height: 100dvh !important;
    border-radius: 0 !important;
    padding-bottom: env(safe-area-inset-bottom) !important;
  }

  #chat-wrapper {
    width: 100% !important;
    height: 100% !important;
  }

  #chat {
    width: 100% !important;
    height: 100% !important;
  }

  body.vambe-chat-open {
    overflow: hidden !important;
    height: 100vh !important;
  }
}
</style>